




































import Vue from "vue";
import Multiselect from "vue-multiselect";
import RequiredLabel from "./../interface/RequiredLabel.vue";
export default Vue.extend({
  name: "select-input",
  components: { Multiselect, RequiredLabel },
  props: {
    id: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    value: {},
    selectValues: {
      type: Array,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isDirty: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  methods: {
    updateValue(value): void {
      this.$emit("input", value);
    },
    emitCloseEvent(value): void {
      this.$emit("close", value);
    },
  },
  computed: {
    isRequired(): boolean {
      return this.required;
    },
  },
});
